(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /*
     * For CF7. Handles additional logic on the multiple choice form.
     * Based on industry selection, show only related interests.
     * Currently only for the dental interest question to be available for the dental industries.
     */

    (function () {
        const choiceForms = document.querySelectorAll('.multichoice-form');
        if (!choiceForms.length) {
            return;
        }

        choiceForms.forEach((choiceForm) => {
            const industryList = choiceForm.querySelector('.industry');
            const selectList = choiceForm.querySelector('.multichoice');

            if (!(industryList || selectList)) {
                return;
            }

            // This will allow us to easily create new functionality
            // for other industries in the future, if needed.
            industryList.addEventListener('change', function handleChange(event) {
                // This gets the industry to compare
                let selection = this.options[this.selectedIndex].value;
                // Then find all the questions
                let options = Array.from(selectList.options);
                // Now we can do whatever, based on the industry selected and the content of the questions

                // Dental test: Only allow the dental question to be selected if
                // the industry matches one of the dental options
                // First make sure there's even a dental question available...
                let dentalTarget = options.filter(option => option.value.includes("Dental"))[0];
                if (dentalTarget) {
                    switch (selection) {
                        case 'Lab':
                        case 'Thermo':
                            dentalTarget.disabled = false;
                            break;
                        default:
                            dentalTarget.disabled = true;
                            break;
                    }
                }
            });
        });
    })();

}));
